function dedupeNewsReadIds(ids: number[]): number[] {
  return [...new Set(
    ids
      .map(id => Number(id))
      .filter(id => Number.isInteger(id) && id > 0),
  )]
}

export function useBigNewsRead() {
  const readIds = useState<number[]>('big-news-read', () => [])

  const markRead = (newsId: number) => {
    readIds.value = dedupeNewsReadIds([...readIds.value, newsId])
    return readIds.value
  }

  const hasRead = (newsId: number) => {
    return readIds.value.includes(newsId)
  }

  return {
    hasRead,
    markRead,
    readIds,
  }
}
